module.exports = __webpack_public_path__ + "static-m/img/car-t-no.47b4f267.png";